// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html

import O1HD from "../../../../../engines/gameEngine";
import PageBase from "../../../../../engines/modules/uiModule/PageBase";
import { ITerrorPagePrams } from "./Interface";


const {ccclass, property, menu} = cc._decorator;

@ccclass
@menu('游戏页面/微恐提示页面')
export default class TerrorPage extends PageBase{

    private IcanCall:()=>void=null;

    private notCall:()=>void=null;

    async OnPageOpen(prams: ITerrorPagePrams) {
        super.OnPageOpen(prams);

        this.IcanCall=prams.canCall;
        this.notCall=prams.not;
    }

    OnBtnIcan()
    {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.IcanCall&&this.IcanCall();
        this.ClosePage();
    }

    OnBtnNot()
    {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.notCall&&this.notCall();
        this.OnMainBtn()
    }

    // update (dt) {}
}
